var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05037 0.636643C1.65984 0.246119 1.02668 0.246119 0.636155 0.636643C0.245631 1.02717 0.245631 1.66033 0.636155 2.05086L5.58591 7.00061L0.636168 11.9504C0.245643 12.3409 0.245643 12.974 0.636168 13.3646C1.02669 13.7551 1.65986 13.7551 2.05038 13.3646L7.00012 8.41482L11.9499 13.3646C12.3404 13.7551 12.9736 13.7551 13.3641 13.3646C13.7546 12.974 13.7546 12.3409 13.3641 11.9504L8.41434 7.00061L13.3641 2.05086C13.7546 1.66033 13.7546 1.02717 13.3641 0.636643C12.9736 0.246119 12.3404 0.246119 11.9499 0.636643L7.00012 5.5864L2.05037 0.636643Z",
    fill: "#4FB1EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.121a8741.svg";
export { ForwardRef as ReactComponent };